import { module } from "modujs";

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onClickBind = this.onClick.bind(this);

        // UI
        this.$el = this.el;
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$el.addEventListener("click", this.onClickBind);
    }

    unbindEvents() {
        this.$el.removeEventListener("click", this.onClickBind);
    }

    ///////////////
    // Callbacks
    ///////////////
    onClick(e) {
        e.preventDefault();

        const id = this.$el.getAttribute("href");
        const $target = document.querySelector(`${id}`);

        if (!$target) return;
        this.call("scrollTo", [$target, { duration: 600 }], "Scroll");
    }

    ///////////////
    // Methods
    ///////////////
}
